import { createAsyncActionType } from './index';

export const ADD_WORKOUT = createAsyncActionType('workouts', 'ADD_WORKOUT');
